import axios from 'axios'
import fileDownload from 'js-file-download'
import { useLocation } from 'react-router-dom'

export const arrayRemove = (array: Array<any>, key: any) => {
  let index: number = array.indexOf(key)
  while (index > -1) {
    array.splice(index, 1)
    index = array.indexOf(key)
  }
  return array
}

export const download = (url: string, filename: string) => {
  axios({ url, responseType: 'blob' }).then((response) => {
    fileDownload(response.data, filename)
  })
}

export const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const setdefault = (obj: { [key: string]: any }, key: string, value: () => any) => {
  if (!(key in obj)) {
    obj[key] = value()
  }
  return obj[key]
}
